import { TAB_FULL_SCREEN_WIDTH, TAB_FULL_WIDTH } from 'theme/constants';

export const largeWrapperStyle = {
  ['@media (min-width: 1440px)']: {
    width: 1272,
  },

  ['@media (max-width: 1440px)']: {
    width: TAB_FULL_WIDTH,
  },
};

export const smallWrapperStyle = {
  ['@media (min-width: 480px)']: {
    width: 480,
  },

  ['@media (max-width: 480px)']: {
    width: TAB_FULL_WIDTH,
  },
};

export const fullScreenStyle = {
  width: TAB_FULL_SCREEN_WIDTH,
};
